(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5247],{

/***/ 38024:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop-cart",
      function () {
        return __webpack_require__(43926);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 10289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MB": function() { return /* binding */ fileDownloadHelper; },
/* harmony export */   "b5": function() { return /* binding */ pdfDownloadHelper; }
/* harmony export */ });
/* unused harmony export excelDownloadHelper */
/* harmony import */ var _pages_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44754);
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11769);


// excel 파일 다운로드 반환 함수
var excelDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split("=")[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// pdf 파일 다운로드 반환 함수
var pdfDownloadHelper = function(file) {
    var blob = new Blob([
        file.data
    ], {
        type: file.headers["content-type"],
        encoding: "UTF-8"
    });
    // 파일명 디코딩
    var name = decodeURI(file.headers["content-disposition"]);
    // fileName = getFileName(name);
    if (window.navigator.msSaveOrOpenBlob) {
        // IE 10+는 해당 함수 제공
        window.navigator.msSaveOrOpenBlob(blob);
    } else {
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.target = "_self";
        if (name) link.download = name.split('"')[1];
        link.click();
        window.URL.revokeObjectURL(link); //메모리 누수 방지
    }
};
// 파일 다운로드 반환 함수
var fileDownloadHelper = function(fileUrl) {
    var fileName = (0,_helper__WEBPACK_IMPORTED_MODULE_1__/* .getFileName */ .UO)(fileUrl);
    var a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileName;
    a.target = "_blank";
    a.click();
};


/***/ }),

/***/ 44649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_1__);


var NasaVariable = function(props) {
    var type = props.type, value = props.value;
    // 네이버 분석 전환 스크립트
    // type: 전환 타입
    // value: 전환 가치
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_1___default()), {
            id: "nasa_variable",
            strategy: "afterInteractive",
            children: '\n        if (!wcs_add) var wcs_add={};\n        wcs_add["wa"] = "s_53d3817a0ea3";\n        var _nasa={};\n        if (window.wcs) {\n          _nasa["cnv"] = wcs.cnv('.concat(type, ",").concat(value, ");\n        wcs_do(_nasa);\n        }\n        var _nasa={};\n        ")
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NasaVariable);


/***/ }),

/***/ 57416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64384);
/* harmony import */ var _api_baskets__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18682);
/* harmony import */ var _common_splicePrice__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(8025);
/* harmony import */ var _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68866);
/* harmony import */ var _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(43181);
/* harmony import */ var _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4557);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55150);
/* harmony import */ var _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83173);
/* harmony import */ var _common_auth__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48106);
/* harmony import */ var _SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74971);
/* harmony import */ var _api_products__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81628);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
















var SingleProduct = function(param) {
    var product1 = param.product, basketsItems = param.basketsItems, cartItems = param.cartItems, basketsCount = param.basketsCount, _$addToCart = param.addToCart, addToWishlist = param.addToWishlist, _$openQuickView = param.openQuickView, _$increaseCnt = param.increaseCnt, _$showToastAlert = param.showToastAlert, _$insertBasketsAction = param.insertBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, dummyList = param.dummyList, addCart = param.addCart, inCart = param.inCart;
    var inBasket = inCart ? inCart(product1) : (basketsItems === null || basketsItems === void 0 ? void 0 : basketsItems.find(function(basketsItem) {
        return basketsItem.pcode === product1.pcode;
    })) || (cartItems === null || cartItems === void 0 ? void 0 : cartItems.find(function(cartItem) {
        return cartItem.pcode === product1.pcode;
    }));
    var handleCart = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(product) {
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (product) {
                            dataLayer.push({
                                ecommerce: null
                            }); // Clear the previous ecommerce object.
                            dataLayer.push({
                                event: "add_to_cart",
                                ecommerce: {
                                    items: [
                                        {
                                            item_name: product.pname,
                                            item_id: product.pcode,
                                            price: product.price,
                                            item_brand: product.supplier,
                                            item_category: product.category_code.length > 2 ? product.category_code : dummyList === null || dummyList === void 0 ? void 0 : dummyList.category[product.category_code]
                                        }, 
                                    ]
                                }
                            });
                            // 채널톡 장비구니 이벤트
                            window.ChannelIO("track", "AddToCart", {
                                pcode: product.pcode
                            });
                        }
                        if ((0,_common_auth__WEBPACK_IMPORTED_MODULE_9__/* .getCookie */ .ej)("token")) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _$addToCart(product));
                    case 5:
                        return _ctx.abrupt("return", _$insertBasketsAction(product, 1));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleCart(product) {
            return _ref.apply(this, arguments);
        };
    }();
    var moveToDetail = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewCount",
                            pcode: product1.pcode
                        };
                        _ctx.next = 3;
                        return (0,_api_products__WEBPACK_IMPORTED_MODULE_11__/* .ViewCountProduct */ .Ir)(body);
                    case 3:
                        res = _ctx.sent;
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function moveToDetail() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Wrapper */ .im, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImgWrapper */ .Q5, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductImg */ .pm, {
                                onClick: moveToDetail,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                    src: product1.main_image,
                                    alt: ""
                                })
                            })
                        }),
                        product1.sfnz_view === "Y" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .SfnzBadge */ .L4, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                src: "https://file.caretbio.com/caretbio/75378c147862e82d7a9ede3651163fdd.png",
                                alt: "SFNZ_badge"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductContentWrapper */ .ZD, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/products/".concat(product1 === null || product1 === void 0 ? void 0 : product1.ename, "/").concat(product1.pcode, "/"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductName */ .rZ, {
                                onClick: moveToDetail,
                                children: product1.pname
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ProductBottomWrapper */ .qW, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceWrapper */ .vN, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .PriceBox */ .bz, {
                                        children: [
                                            product1.salePer > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("span", {
                                                        children: [
                                                            product1.salePer,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                        children: product1.price && " ".concat((0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.price), "\uC6D0")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "d-flex",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h5", {
                                                    children: [
                                                        (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.discount_price),
                                                        "\uC6D0"
                                                    ]
                                                })
                                            }),
                                            Number(product1.quantity) > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                style: {
                                                    // paddingBottom: "5px",
                                                    fontSize: "14px"
                                                },
                                                children: [
                                                    "\uAC1C\uB2F9",
                                                    " ",
                                                    (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(Math.floor(Number(product1.discount_price) / Number(product1.quantity))),
                                                    "\uC6D0"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                product1.sold_out === "Y" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                        children: "\uD488\uC808"
                                    })
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .CartIconBox */ .d4, {
                                    children: !inBasket ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        className: "mobonCart",
                                        onClick: function(e) {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-add"
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                        onClick: function(e) {
                                            return addCart ? addCart(product1) : handleCart(product1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                                            className: "fi-rs-shopping-cart-check"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .StickerWrapper */ .Mo, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .ViewBox */ .HA, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            (0,_common_splicePrice__WEBPACK_IMPORTED_MODULE_12__/* .priceComma */ .a)(product1.point),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SingleProduct_styles__WEBPACK_IMPORTED_MODULE_10__/* .Sticker */ .My, {
                                                children: "P"
                                            }),
                                            " \uC801\uB9BD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: "/assets/imgs/theme/icons/icon-view.png"
                                            }),
                                            product1.hit
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        basketsItems: state.baskets.items,
        basketsCount: state.baskets.count
    };
};
var mapDispatchToProps = {
    addToCart: _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__/* .addToCart */ .Xq,
    openQuickView: _redux_action_quickViewAction__WEBPACK_IMPORTED_MODULE_14__/* .openQuickView */ .$,
    increaseCnt: _redux_action_cart__WEBPACK_IMPORTED_MODULE_13__/* .increaseCnt */ .us,
    showToastAlert: _redux_action_alert__WEBPACK_IMPORTED_MODULE_5__/* .showToastAlert */ .I,
    insertBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .insertBasketsAction */ .el,
    fetchBasketsAction: _redux_action_baskets__WEBPACK_IMPORTED_MODULE_8__/* .fetchBasketsAction */ .Ei
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(SingleProduct));


/***/ }),

/***/ 43926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ shop_cart; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/cart/cart-styles.js
var cart_styles = __webpack_require__(67503);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./redux/action/cart.js
var cart = __webpack_require__(68866);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/baskets.js
var baskets = __webpack_require__(18682);
// EXTERNAL MODULE: ./common/auth.js + 4 modules
var auth = __webpack_require__(48106);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./redux/action/baskets.js
var action_baskets = __webpack_require__(83173);
// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./api/order.js
var order = __webpack_require__(50059);
// EXTERNAL MODULE: ./common/util/getUserAgent.js
var getUserAgent = __webpack_require__(90481);
// EXTERNAL MODULE: ./common/files.js
var files = __webpack_require__(10289);
// EXTERNAL MODULE: ./components/ecommerce/singleProduct/SingleProduct.js
var SingleProduct = __webpack_require__(57416);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 91 modules
var swiper_esm = __webpack_require__(8701);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./components/cart/recomSlider.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}






swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Autoplay */.pt,
    swiper_esm/* Scrollbar */.LW,
    swiper_esm/* Pagination */.tl,
    swiper_esm/* Grid */.rj
]);
var RecomSlider = function(param) {
    var relatedProducts = param.relatedProducts;
    var ref = (0,react.useState)(null), recomSwiper = ref[0], setRecomSwiper = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* RecommendedSliderWrapper */.Nw, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                spaceBetween: 20,
                navigation: {
                    prevEl: ".custom_prev_rl",
                    nextEl: ".custom_next_rl"
                },
                className: "",
                slidesPerView: 2,
                slidesPerGroup: 2,
                breakpoints: {
                    575: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    768: {
                        slidesPerView: 2,
                        slidesPerGroup: 2
                    },
                    992: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    1440: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    }
                },
                onSwiper: function(swiper) {
                    return setRecomSwiper(swiper);
                },
                onSlideChange: function(swiper) {
                    return setRecomSwiper(_objectSpread({}, recomSwiper, {
                        realIndex: swiper.realIndex
                    }));
                },
                initialSlide: 0,
                scrollbar: true,
                children: relatedProducts && relatedProducts.map(function(item, itemIdx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SingleProduct/* default */.Z, {
                            product: item
                        })
                    }, itemIdx);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "slider_nav",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "custom_prev_rl",
                        style: {
                            visibility: recomSwiper && (recomSwiper === null || recomSwiper === void 0 ? void 0 : recomSwiper.realIndex) == 0 ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-arrow-small-left"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "custom_next_rl",
                        style: {
                            visibility: recomSwiper && (recomSwiper === null || recomSwiper === void 0 ? void 0 : recomSwiper.realIndex) + (Number(recomSwiper === null || recomSwiper === void 0 ? void 0 : recomSwiper.currentBreakpoint) < 992 ? 2 : 3) >= (relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.length) ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                            className: "fi-rs-arrow-small-right"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var recomSlider = (RecomSlider);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
;// CONCATENATED MODULE: ./components/cart/cart.js







var Cart = function(param) {
    var cartProducts = param.cartProducts, deleteAll = param.deleteAll, selectAllItems = param.selectAllItems, selectedItem = param.selectedItem, selectItem = param.selectItem, increaseBasketProduct = param.increaseBasketProduct, decreaseBasketProduct = param.decreaseBasketProduct, isUser = param.isUser, decreaseCnt = param.decreaseCnt, increaseCnt = param.increaseCnt, handleDelete = param.handleDelete, cartEstimate = param.cartEstimate, onClickCheckout = param.onClickCheckout, naverpayCheckout = param.naverpayCheckout, checkDeliveryPrice = param.checkDeliveryPrice, price = param.price, deliveryPrice = param.deliveryPrice, nonCheckDelPrice = param.nonCheckDelPrice, purchaseDirect = param.purchaseDirect, confirmItems = param.confirmItems, setSelectModal = param.setSelectModal, relatedProducts = param.relatedProducts, relatedLoading = param.relatedLoading;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartSection */.sP, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        cartProducts && cartProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartBody */.xH, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartHeader */.Qc, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-flex all-check",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "custome-checkbox",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "checkbox",
                                                            className: "form-check-input",
                                                            id: "all",
                                                            onChange: function(e) {
                                                                return selectAllItems(e);
                                                            },
                                                            checked: selectedItem.includes(false) ? false : true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                            className: "form-check-label",
                                                            htmlFor: "all",
                                                            style: {
                                                                textTransform: "capitalize"
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "\uBAA8\uB450\uC120\uD0DD"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "ml-10",
                                                    children: [
                                                        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.length,
                                                        " / ",
                                                        cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.length
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-flex delete",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: function() {
                                                    return deleteAll();
                                                },
                                                children: "\uC804\uCCB4 \uC0AD\uC81C"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartMainWrapper */.J_, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* CartListWrapper */.qK, {
                                            children: cartProducts && cartProducts.map(function(item, i) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(cart_styles/* CartItem */.bE, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "d-flex info",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "custome-checkbox",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            type: "checkbox",
                                                                            className: "form-check-input",
                                                                            id: "".concat(item.pcode),
                                                                            value: item.pcode ? item.pcode : "",
                                                                            onChange: selectItem(i, item),
                                                                            checked: selectedItem[i] === true ? true : false
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                            className: "form-check-label",
                                                                            htmlFor: "".concat(item.pcode),
                                                                            style: {
                                                                                textTransform: "capitalize"
                                                                            }
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* ItemInfo */.S8, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "d-flex mb-10",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* ItemImg */.f7, {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        href: "/products/".concat(item.ename, "/").concat(item.pcode),
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                            src: item.main_image,
                                                                                            style: {
                                                                                                cursor: "pointer"
                                                                                            }
                                                                                        })
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "d-flex flex-column w-100",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                                            className: "pname",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                    href: "/products/".concat(item.ename, "/").concat(item.pcode),
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                        children: item.pname
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                    onClick: function(e) {
                                                                                                        return handleDelete(item, i);
                                                                                                    },
                                                                                                    className: "remove",
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                        className: "fi-rs-trash"
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "deliveryInfo",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: item.delivery_type_korea === "\uBB34\uB8CC" || item.delivery_type_korea === "\uCC29\uBD88" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                                        children: "".concat(item.delivery_type_korea, "\uBC30\uC1A1")
                                                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                                        children: item.delivery_type_korea + " " + (0,splicePrice/* priceComma */.a)(item === null || item === void 0 ? void 0 : item.delivery_price) + "\uC6D0"
                                                                                                    })
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "divide",
                                                                                                    children: "|"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: item.deadline > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                                        children: [
                                                                                                            item.deadline,
                                                                                                            "\uC2DC\uAE4C\uC9C0 \uC8FC\uBB38\uC2DC \uB2F9\uC77C \uBC1C\uC1A1"
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* ItemPrice */.tv, {
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "option",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "\uB2E8\uAC00 :",
                                                                                                        " " + (0,splicePrice/* priceComma */.a)(Math.round(Number(item.discount_price) / Number(item.quantity))),
                                                                                                        "\uC6D0"
                                                                                                    ]
                                                                                                }),
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                "/ ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "\uBB36\uC74C\uC218\uB7C9 : ",
                                                                                                        item.quantity,
                                                                                                        "\uAC1C"
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        !(item.horizontal == 0 && item.vertical == 0 && item.height == 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                "/",
                                                                                                " ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "\uC0AC\uC774\uC988 :",
                                                                                                        " ",
                                                                                                        (item.horizontal != 0 ? item.horizontal : "-") + (item.vertical != 0 ? "X" + item.vertical : "") + (item.height != 0 ? "X" + item.height : "")
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item.golgi && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                "/ ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "\uACE8\uC9C0 : ",
                                                                                                        item.golgi
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item.strength && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                "/ ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                                    children: [
                                                                                                        "\uAC15\uB3C4 : ",
                                                                                                        item.strength
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        item.feature && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                                            children: [
                                                                                                "/ ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: item.feature
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "cntPrice",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "cnt",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                    className: "fi-rs-minus-small mr-10",
                                                                                                    onClick: function(e) {
                                                                                                        return isUser ? decreaseBasketProduct(item) : decreaseCnt(item.pcode);
                                                                                                    }
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: item.cnt
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                    className: "fi-rs-plus-small ml-10",
                                                                                                    onClick: function(e) {
                                                                                                        return isUser ? increaseBasketProduct(item) : increaseCnt(item.pcode);
                                                                                                    }
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                                                                            className: "price",
                                                                                            children: [
                                                                                                (0,splicePrice/* priceComma */.a)(Number(item.discount_price) * Number(item.cnt)),
                                                                                                "\uC6D0"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "direct",
                                                                            onClick: purchaseDirect(item),
                                                                            children: "\uAC1C\uBCC4 \uBC14\uB85C \uAD6C\uB9E4"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "delivery_price",
                                                            children: [
                                                                "\uBC30\uC1A1\uB8CC: ",
                                                                checkDeliveryPrice(item)
                                                            ]
                                                        })
                                                    ]
                                                }, i);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* MobileCartSummary */.Ap, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartStickyInner */.pV, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uCD1D \uC0C1\uD488\uAE08\uC561"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: (0,splicePrice/* priceComma */.a)(price()) + "\uC6D0"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uCD1D \uBC30\uC1A1\uBE44"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "+" + (0,splicePrice/* priceComma */.a)(nonCheckDelPrice()) + "\uC6D0"
                                                                    })
                                                                ]
                                                            }),
                                                            deliveryPrice() - nonCheckDelPrice() !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: deliveryPrice() - nonCheckDelPrice() < 0 ? "text-danger" : "",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: deliveryPrice() - nonCheckDelPrice() < 0 && "\uBB36\uC74C \uBC30\uC1A1 \uD560\uC778"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            (0,splicePrice/* priceComma */.a)(deliveryPrice() - nonCheckDelPrice()),
                                                                            "\uC6D0"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uC608\uC0C1 \uACB0\uC81C\uAE08\uC561"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            (0,splicePrice/* priceComma */.a)(price() + deliveryPrice()),
                                                                            "\uC6D0"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "info",
                                                        children: "* \uCD5C\uC885 \uACB0\uC81C \uAE08\uC561\uC740 \uB3C4\uC11C\uC0B0\uAC04 \uD560\uC99D, \uCFE0\uD3F0 \uC0AC\uC6A9 \uB4F1\uC73C\uB85C \uC778\uD574 \uBCC0\uB3D9\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* RecommendedWrapper */.VZ, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                    className: "title",
                                                    children: "\uC774\uB7F0 \uC0C1\uD488\uC740 \uC548\uD544\uC694\uD558\uC138\uC694?"
                                                }),
                                                relatedLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-center align-items-center",
                                                    style: {
                                                        minHeight: "300px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
                                                }),
                                                !relatedLoading && relatedProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(recomSlider, {
                                                    relatedProducts: relatedProducts
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* CartSummaryWrapper */.S4, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartStickyWrapper */.aV, {
                                        id: "sticky",
                                        className: "sticky",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* CartStickyInner */.pV, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uCD1D \uC0C1\uD488\uAE08\uC561"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: (0,splicePrice/* priceComma */.a)(price()) + "\uC6D0"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uCD1D \uBC30\uC1A1\uBE44"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "+" + (0,splicePrice/* priceComma */.a)(nonCheckDelPrice()) + "\uC6D0"
                                                                    })
                                                                ]
                                                            }),
                                                            deliveryPrice() - nonCheckDelPrice() !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                className: deliveryPrice() - nonCheckDelPrice() < 0 ? "text-danger" : "",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: deliveryPrice() - nonCheckDelPrice() < 0 && "\uBB36\uC74C \uBC30\uC1A1 \uD560\uC778"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            (0,splicePrice/* priceComma */.a)(deliveryPrice() - nonCheckDelPrice()),
                                                                            "\uC6D0"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: "\uC608\uC0C1 \uACB0\uC81C\uAE08\uC561"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        children: [
                                                                            (0,splicePrice/* priceComma */.a)(price() + deliveryPrice()),
                                                                            "\uC6D0"
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "info",
                                                        children: "* \uCD5C\uC885 \uACB0\uC81C \uAE08\uC561\uC740 \uB3C4\uC11C\uC0B0\uAC04 \uD560\uC99D, \uCFE0\uD3F0 \uC0AC\uC6A9 \uB4F1\uC73C\uB85C \uC778\uD574 \uBCC0\uB3D9\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* BtnWrapper */.Bo, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "btns",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "basic_btns",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "/products/No-Tape-Box/",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: "btn border_btn",
                                                                        children: "\uC1FC\uD551 \uACC4\uC18D\uD558\uAE30"
                                                                    })
                                                                }),
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "naver-btn",
                                                                        onClick: function() {
                                                                            return setSelectModal(true);
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: "/assets/imgs/product/payment_icon_naver.png",
                                                                                alt: "\uB124\uC774\uBC84\uD398\uC774 \uAD6C\uB9E4"
                                                                            }),
                                                                            "\uAD6C\uB9E4"
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "btn estimate",
                                                            onClick: function() {
                                                                return cartEstimate();
                                                            },
                                                            children: "\uACAC\uC801\uC11C \uB2E4\uC6B4\uB85C\uB4DC"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            onClick: onClickCheckout,
                                                            className: "btn",
                                                            children: [
                                                                confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.length,
                                                                "\uAC1C \uAD6C\uB9E4\uD558\uAE30"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        cartProducts && cartProducts.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(cart_styles/* EmptyWrapper */.zD, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: "https://file.caretbio.com/caretbio/45e80cfaa7288992d1f6826ebd3db173.png",
                                    alt: "empty-cart"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    className: "title",
                                    children: "\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uAE34 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/products/No-Tape-Box/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn",
                                            children: "\uC0C1\uD488 \uB2F4\uC73C\uB7EC \uAC00\uAE30"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                cartProducts && cartProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* MobileBtnSticky */.aZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_styles/* BtnWrapper */.Bo, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "btns",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "basic_btns",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "btn estimate",
                                            onClick: function() {
                                                return cartEstimate();
                                            },
                                            children: "\uACAC\uC801\uC11C \uB2E4\uC6B4\uB85C\uB4DC"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "naver-btn",
                                                onClick: function() {
                                                    return setSelectModal(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/imgs/product/payment_icon_naver.png",
                                                        alt: "\uB124\uC774\uBC84\uD398\uC774 \uAD6C\uB9E4"
                                                    }),
                                                    "\uAD6C\uB9E4"
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    onClick: onClickCheckout,
                                    className: "btn",
                                    children: [
                                        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.length,
                                        "\uAC1C \uACB0\uC81C\uD558\uAE30"
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var cart_cart = (Cart);

// EXTERNAL MODULE: ./components/elements/requestLoginModal.js
var requestLoginModal = __webpack_require__(56177);
// EXTERNAL MODULE: ./components/products/detail/ProductDetails-styles.js
var ProductDetails_styles = __webpack_require__(26824);
// EXTERNAL MODULE: ./common/scripts/NasaVariable.js
var NasaVariable = __webpack_require__(44649);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/shop-cart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function shop_cart_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function shop_cart_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            shop_cart_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


























var CartPage = function(param) {
    var cartItems = param.cartItems, _$increaseCnt = param.increaseCnt, _$decreaseCnt = param.decreaseCnt, _$deleteFromCart = param.deleteFromCart, _$clearCart = param.clearCart, _$deleteBasketsAction = param.deleteBasketsAction, _$fetchBasketsAction = param.fetchBasketsAction, basketItems = param.basketItems, basketCount = param.basketCount, _$clearBasketsAction = param.clearBasketsAction, _$modifyConfirmModal = param.modifyConfirmModal, _$openConfirmModal = param.openConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, userDevice = param.userDevice, userInfo = param.userInfo;
    var ref9 = (0,react.useState)(null), cartProducts = ref9[0], setCartProducts = ref9[1];
    var router = (0,next_router.useRouter)();
    // 선택 상품
    var ref1 = (0,react.useState)([]), selectedItem = ref1[0], setSelectedItem = ref1[1];
    var ref2 = (0,react.useState)([]), confirmItems = ref2[0], setConfirmItems = ref2[1];
    var ref3 = (0,react.useState)(false), openLoginModal = ref3[0], setOpenLoginModal = ref3[1];
    var ref4 = (0,react.useState)({}), directProduct = ref4[0], setDirectProduct = ref4[1];
    var ref5 = (0,react.useState)(false), selectModal = ref5[0], setSelectModal = ref5[1];
    var ref6 = (0,react.useState)(false), cartLoading = ref6[0], setCartLoading = ref6[1];
    var ref7 = (0,react.useState)([]), relatedProducts = ref7[0], setRelatedProducts = ref7[1];
    var ref8 = (0,react.useState)(false), relatedLoading = ref8[0], setRelatedLoading = ref8[1];
    var isUser = (0,react.useMemo)(function() {
        var ref;
        if (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) {
            return true;
        } else {
            return false;
        }
    }, [
        userInfo
    ]);
    // 토큰 유무 판별
    var checkToken = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isUser) {
                            _ctx.next = 9;
                            break;
                        }
                        if (basketItems) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setCartProducts(basketItems);
                        setSelectedItem(new Array(basketItems ? basketItems.length : 1).fill(true));
                        setConfirmItems(basketItems);
                        setCartLoading(false);
                        _ctx.next = 10;
                        break;
                    case 9:
                        {
                            setCartProducts(cartItems);
                            setSelectedItem(new Array(cartItems ? cartItems.length : 1).fill(true));
                            setConfirmItems(cartItems);
                            setCartLoading(false);
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function checkToken() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 연관상품 불러오기
    var fetchRelated = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref, ref10, ref11;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(relatedProducts && relatedProducts.length > 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        setRelatedLoading(true);
                        _ctx.prev = 3;
                        body = {
                            modes: "RelationProducts",
                            items: JSON.stringify(cartProducts.map(function(el) {
                                return el.pcode;
                            }))
                        };
                        _ctx.next = 7;
                        return (0,baskets/* basketsAPI */.$S)(body);
                    case 7:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            setRelatedProducts((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Rows);
                            setRelatedLoading(false);
                        } else {
                            ;
                            (0,common_alert/* failAlert */.qh)((ref10 = res.Data) === null || ref10 === void 0 ? void 0 : ref10.Msg);
                            console.error((ref11 = res.Data) === null || ref11 === void 0 ? void 0 : ref11.Msg);
                            setRelatedLoading(false);
                        }
                        _ctx.next = 15;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        console.error(_ctx.t0);
                        setRelatedLoading(false);
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        }));
        return function fetchRelated() {
            return _ref.apply(this, arguments);
        };
    }();
    // 결제하기
    var onClickCheckout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!((cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.length) < 1)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"));
                    case 3:
                        if (!(((ref = confirmItems.filter(function(el) {
                            return el != undefined;
                        })) === null || ref === void 0 ? void 0 : ref.length) < 1)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC120\uD0DD\uB41C \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"));
                    case 5:
                        sessionStorage.setItem("cartOrder", JSON.stringify(confirmItems.filter(function(el) {
                            return el != undefined;
                        })));
                        router.push({
                            pathname: "/checkout",
                            query: {
                                type: "cart"
                            }
                        });
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onClickCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 삭제
    var deleteBasketProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(item) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _$deleteBasketsAction(item);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function deleteBasketProduct(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 삭제 모달
    var handleDelete = function(item, i) {
        var content = {
            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
            actionBtnLabel: "\uD655\uC778",
            actionBtnValid: true,
            cancelBtnLabel: "\uCDE8\uC18C",
            onAction: function() {
                var ref;
                (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.ukey) ? deleteBasketProduct(item, i) : _$deleteFromCart(item.pcode, i);
                confirmItems.splice(i, 1);
                setConfirmItems(_toConsumableArray(confirmItems));
                selectedItem.splice(i, 1);
                setSelectedItem(_toConsumableArray(selectedItem));
                _$closeConfirmModal();
            }
        };
        _$modifyConfirmModal(content);
        _$openConfirmModal();
    };
    // 회원 장바구니 갯수 증가
    var increaseBasketProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(item) {
            var i, body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        i = cartProducts.findIndex(function(el) {
                            return el.pcode === item.pcode;
                        });
                        cartProducts[i].cnt = Number(cartProducts[i].cnt) + 1;
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify([
                                {
                                    pcode: item.pcode,
                                    cnt: cartProducts[i].cnt
                                }
                            ])
                        };
                        _ctx.next = 5;
                        return (0,baskets/* insertBaskets */.nh)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setConfirmItems(data === null || data === void 0 ? void 0 : data.data);
                            setCartProducts(data === null || data === void 0 ? void 0 : data.data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function increaseBasketProduct(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 회원 장바구니 갯수 감소
    var decreaseBasketProduct = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(item) {
            var i, body, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        i = cartProducts.findIndex(function(el) {
                            return el.pcode === item.pcode;
                        });
                        if (cartProducts[i].cnt > 1) cartProducts[i].cnt = Number(cartProducts[i].cnt) - 1;
                        body = {
                            modes: "InsertSet",
                            items: JSON.stringify([
                                {
                                    pcode: item.pcode,
                                    cnt: cartProducts[i].cnt
                                }
                            ])
                        };
                        _ctx.next = 5;
                        return (0,baskets/* insertBaskets */.nh)(body);
                    case 5:
                        data = _ctx.sent;
                        if ((data === null || data === void 0 ? void 0 : data.code) === "0000") {
                            setConfirmItems(data === null || data === void 0 ? void 0 : data.data);
                            setCartProducts(data === null || data === void 0 ? void 0 : data.data);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function decreaseBasketProduct(item) {
            return _ref.apply(this, arguments);
        };
    }();
    // 네이버 주문
    var naverpayCheckout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, UserAgent, widerplanet_device, ref, ref12, ref13;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _$isLoading();
                        _ctx.prev = 1;
                        body = {
                            modes: "OrderTemp",
                            division: "store",
                            price: price1() + deliveryPrice(),
                            naverYn: "Y",
                            items: JSON.stringify(confirmItems.filter(function(el) {
                                return el != undefined;
                            })),
                            flowCode: (0,auth/* getCookie */.ej)("NA_CO"),
                            clickId: (0,auth/* getCookie */.ej)("NVADID"),
                            slog: sessionStorage.getItem("slog") || "",
                            mobileYn: userDevice === "mobile" ? "Y" : "N"
                        };
                        _ctx.next = 5;
                        return (0,order/* StoreOrderApi */.RJ)(body);
                    case 5:
                        res = _ctx.sent;
                        if ((res === null || res === void 0 ? void 0 : res.Code) === "0000") {
                            UserAgent = (0,getUserAgent/* default */.Z)();
                            widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
                            if (widerplanet_device === "web") {
                                ;
                                window.open("https://order.pay.naver.com/customer/buy/".concat(res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : ref.sertParam));
                            }
                            if (widerplanet_device === "mobile") {
                                ;
                                router.push("https://m.pay.naver.com/o/customer/buy/".concat(res === null || res === void 0 ? void 0 : (ref12 = res.Data) === null || ref12 === void 0 ? void 0 : ref12.sertParam));
                            }
                            _$isLoaded();
                        } else {
                            ;
                            _$isLoaded();
                            (0,common_alert/* failAlert */.qh)(res === null || res === void 0 ? void 0 : (ref13 = res.Data) === null || ref13 === void 0 ? void 0 : ref13.Msg);
                        }
                        _ctx.next = 14;
                        break;
                    case 9:
                        _ctx.prev = 9;
                        _ctx.t0 = _ctx["catch"](1);
                        _$isLoaded();
                        console.error(_ctx.t0.message);
                        alert(_ctx.t0.message);
                    case 14:
                        _$isLoaded();
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    9
                ]
            ]);
        }));
        return function naverpayCheckout() {
            return _ref.apply(this, arguments);
        };
    }();
    // 장바구니 견적서 생성
    var cartEstimate = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, body, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!(((ref = confirmItems.filter(function(el) {
                            return el != undefined;
                        })) === null || ref === void 0 ? void 0 : ref.length) < 1)) {
                            _ctx.next = 4;
                            break;
                        }
                        (0,common_alert/* failAlert */.qh)("\uACAC\uC801\uC11C\uB97C \uC0DD\uC131\uD560 \uC0C1\uD488\uC744 \uC120\uD0DD\uD574\uC8FC\uC138\uC694.");
                        return _ctx.abrupt("return");
                    case 4:
                        _$isLoading();
                        body = {
                            modes: "Estimate",
                            items: JSON.stringify(confirmItems.filter(function(el) {
                                return el != undefined;
                            }))
                        };
                        _ctx.next = 8;
                        return (0,baskets/* basketsPDF */.ul)(body);
                    case 8:
                        res = _ctx.sent;
                        (0,files/* pdfDownloadHelper */.b5)(res);
                        _$isLoaded();
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function cartEstimate() {
            return _ref.apply(this, arguments);
        };
    }();
    // 전체 선택
    var selectAllItems = function(e) {
        if (e.target.checked) {
            var tempArr = new Array(cartProducts.length).fill(true);
            setSelectedItem(tempArr);
            setConfirmItems(cartProducts);
        } else {
            var tempArr2 = new Array(cartProducts.length).fill(false);
            setSelectedItem(tempArr2);
            setConfirmItems([]);
        }
    };
    // 견적 선택
    var selectItem = function(i, el) {
        return function(e) {
            var tempArr = _toConsumableArray(selectedItem);
            tempArr[i] = e.target.checked;
            setSelectedItem(tempArr);
            if (e.target.checked) {
                var tempArr2 = _toConsumableArray(confirmItems);
                tempArr2.push(el);
                setConfirmItems(tempArr2);
            } else {
                var tempArr21 = _toConsumableArray(confirmItems);
                var index = tempArr21.findIndex(function(product) {
                    return product.pcode === el.pcode;
                });
                tempArr21.splice(index, 1);
                setConfirmItems(tempArr21);
            }
        };
    };
    // 장바구니 비우기
    var deleteAll = function() {
        isUser ? _$clearBasketsAction() : _$clearCart();
    };
    // check deliveryPrice
    var checkDeliveryPrice = function(item) {
        if (item.delivery_type_korea === "\uBB34\uB8CC" || item.delivery_type_korea === "\uCC29\uBD88") {
            return "".concat(item.delivery_type_korea, "\uBC30\uC1A1");
        }
        if (item.bundle === "Y") {
            return item.delivery_type_korea + " " + (0,splicePrice/* priceComma */.a)(Number(item.delivery_price) * Number(item.cnt)) + "\uC6D0" + "(\uAC1C\uBCC4 \uBB36\uC74C \uBC30\uC1A1 \uC0C1\uD488)";
        } else {
            return item.delivery_type_korea + " " + (0,splicePrice/* priceComma */.a)(item === null || item === void 0 ? void 0 : item.delivery_price) + "\uC6D0";
        }
    };
    // 전체 금액
    var price1 = function() {
        var price = 0;
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(item) {
            return price += item.discount_price * item.cnt;
        });
        return price;
    };
    // 할인,할증 없는 배송료
    var nonCheckDelPrice = function() {
        var delPrice = 0;
        confirmItems === null || confirmItems === void 0 ? void 0 : confirmItems.forEach(function(item) {
            return delPrice += (item.delivery_type === "\uBB34\uB8CC" || item.delivery === "\uBB34\uB8CC" ? 0 : item.delivery_price) * (item.bundle === "Y" ? item.cnt : 1);
        });
        return delPrice;
    };
    // 할인,할증 포함 배송료
    var deliveryPrice = function() {
        var delPrice = 0;
        var baesong_temp = [];
        confirmItems.forEach(function(temp_item) {
            var delivery_price_temp = 0;
            if (temp_item.delivery_type === "C" || temp_item.delivery === "C") return 0;
            delivery_price_temp = Number(temp_item.delivery_price);
            var delivery_price = 0;
            if (temp_item.delivery_type === "A" || temp_item.delivery_type === "F" || temp_item.delivery === "A" || temp_item.delivery === "F") {
                if (temp_item.bundle === "Y") {
                    delivery_price = delivery_price_temp * Number(temp_item.cnt);
                } else if (temp_item.bundle === "N") {
                    if (baesong_temp.includes(temp_item.supplier)) {
                        delivery_price = 0;
                    } else {
                        delivery_price = delivery_price_temp;
                        baesong_temp.push(temp_item.supplier);
                    }
                }
            } else {
                delivery_price = delivery_price_temp;
            }
            delPrice += delivery_price;
        });
        return delPrice;
    };
    // 비회원 바로 구매 모달 오픈
    var handleLoginModal = function() {
        setOpenLoginModal(function(prev) {
            return !prev;
        });
    };
    // 개별 바로 구매
    var purchaseDirect = function(product) {
        return function() {
            setDirectProduct(product);
            if (!isUser && !openLoginModal) {
                handleLoginModal();
                return;
            } else {
                sessionStorage.setItem("directOrder", JSON.stringify([
                    shop_cart_objectSpread({}, product, {
                        cnt: product.cnt
                    })
                ]));
                router.push({
                    pathname: "/checkout",
                    query: {
                        type: "direct"
                    }
                });
            }
        };
    };
    (0,react.useEffect)(function() {
        setCartLoading(true);
        checkToken();
    }, [
        userInfo,
        cartItems,
        basketItems
    ]);
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        if (cartProducts && cartProducts.length > 0) {
            var ref14;
            fetchRelated();
            var UserAgent = navigator.userAgent;
            var widerplanet_device = UserAgent.match(/iPhone|iPod|Android|Windows CE|BlackBerry|Symbian|Windows Phone|webOS|Opera Mini|Opera Mobi|POLARIS|IEMobile|lgtelecom|nokia|SonyEricsson/i) != null || UserAgent.match(/LG|SAMSUNG|Samsung/) != null ? "mobile" : "web";
            var wptg_tagscript_vars = globalThis.wptg_tagscript_vars || [];
            wptg_tagscript_vars.push(function() {
                var ref;
                return {
                    wp_hcuid: (userInfo === null || userInfo === void 0 ? void 0 : (ref = userInfo.Member) === null || ref === void 0 ? void 0 : ref.id) || "",
                    ti: "54644",
                    ty: "Cart",
                    device: widerplanet_device,
                    items: cartProducts.map(function(el) {
                        return {
                            i: el.pcode,
                            t: el.pname
                        };
                    })
                };
            });
            (ref14 = globalThis.wptg_tagscript) === null || ref14 === void 0 ? void 0 : ref14.exec();
            // <!-- ADN Tracker[장바구니] start -->
            try {
                if (window.fn_across_adn_contain) {
                    var across_adn_cart_contain = new fn_across_adn_contain();
                    var across_adn_cart_param = [];
                    across_adn_cart_param = {
                        ut: "Cart",
                        ui: "108274",
                        items: cartProducts.map(function(el) {
                            return {
                                i: el.pcode,
                                c: el.pname,
                                q: el.cnt,
                                p: Number(el.cnt) * Number(el.discount_price)
                            };
                        })
                    };
                    across_adn_cart_contain.init(across_adn_cart_param);
                }
            } catch (error) {
                console.error(error);
            }
        // <!-- ADN Tracker[장바구니] end -->
        }
    }, [
        router.isReady,
        cartProducts
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            cartProducts && cartProducts.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(NasaVariable/* default */.Z, {
                type: "3",
                value: "0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                parent: "\uD648",
                sub: "\uC7A5\uBC14\uAD6C\uB2C8",
                pageTitle: SeoMeta/* SeoMeta.cart.title */.e.cart.title,
                pageDesc: SeoMeta/* SeoMeta.cart.description */.e.cart.description,
                pageKeyword: SeoMeta/* SeoMeta.cart.keywords */.e.cart.keywords,
                children: [
                    cartLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "d-flex justify-content-center align-items-center",
                        style: {
                            minHeight: "300px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
                    }),
                    !cartLoading && cartProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_cart, {
                        cartProducts: cartProducts,
                        deleteAll: deleteAll,
                        selectAllItems: selectAllItems,
                        selectedItem: selectedItem,
                        selectItem: selectItem,
                        increaseBasketProduct: increaseBasketProduct,
                        decreaseBasketProduct: decreaseBasketProduct,
                        isUser: isUser,
                        decreaseCnt: _$decreaseCnt,
                        increaseCnt: _$increaseCnt,
                        handleDelete: handleDelete,
                        cartEstimate: cartEstimate,
                        onClickCheckout: onClickCheckout,
                        naverpayCheckout: naverpayCheckout,
                        checkDeliveryPrice: checkDeliveryPrice,
                        price: price1,
                        deliveryPrice: deliveryPrice,
                        nonCheckDelPrice: nonCheckDelPrice,
                        purchaseDirect: purchaseDirect,
                        confirmItems: confirmItems,
                        setSelectModal: setSelectModal,
                        relatedProducts: relatedProducts,
                        relatedLoading: relatedLoading
                    })
                ]
            }),
            openLoginModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(requestLoginModal/* default */.Z, {
                handleLoginModal: handleLoginModal,
                openLoginModal: openLoginModal,
                purchaseDirect: purchaseDirect,
                product: directProduct,
                cnt: directProduct.cnt
            }),
            selectModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails_styles/* NPayModalWrapper */.DW, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "modal-section",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "modal-content",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "desc",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "Npay\uB85C \uACB0\uC81C \uC2DC \uC8FC\uBB38\uB0B4\uC5ED\uC740",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " \uB124\uC774\uBC84\uC5D0\uC11C \uD655\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4. ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uAD6C\uB9E4\uB97C \uC120\uD0DD\uD558\uC2DC\uBA74 \uD3EC\uC778\uD2B8 1% \uC801\uB9BD,",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "\uC801\uB9BD\uAE08 \uC0AC\uC6A9 \uBC0F \uCFE0\uD3F0 \uC801\uC6A9\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "btnWrapper",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "cancel",
                                        onClick: function() {
                                            return setSelectModal(false);
                                        },
                                        children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uAD6C\uB9E4"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "confirm",
                                        onClick: function() {
                                            return naverpayCheckout();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/imgs/product/payment_icon_naver.png",
                                                alt: "\uB124\uC774\uBC84\uD398\uC774 \uAD6C\uB9E4"
                                            }),
                                            "\uAD6C\uB9E4"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
var mapStateToProps = function(state) {
    return {
        cartItems: state.cart,
        activeCart: state.counter,
        basketItems: state.baskets.items,
        basketCount: state.baskets.count,
        loading: state.loading.loading,
        userInfo: state.userInfo
    };
};
var mapDispatchToProps = {
    increaseCnt: cart/* increaseCnt */.us,
    decreaseCnt: cart/* decreaseCnt */.Yl,
    deleteFromCart: cart/* deleteFromCart */.EI,
    clearCart: cart/* clearCart */.LL,
    deleteBasketsAction: action_baskets/* deleteBasketsAction */.Xv,
    fetchBasketsAction: action_baskets/* fetchBasketsAction */.Ei,
    clearBasketsAction: action_baskets/* clearBasketsAction */.Yp,
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h
};
/* harmony default export */ var shop_cart = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(CartPage));


/***/ }),

/***/ 43181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ openQuickView; },
/* harmony export */   "z": function() { return /* binding */ closeQuickView; }
/* harmony export */ });
/* harmony import */ var _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46330);

var openQuickView = function(product) {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .OPEN_QUICK_VIEW */ .GS,
            payload: {
                product: product
            }
        });
    };
};
var closeQuickView = function() {
    return function(dispatch) {
        dispatch({
            type: _constants_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .CLOSE_QUICK_VIEW */ .fJ
        });
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,4754,7503,6177,6824,9774,2888,179], function() { return __webpack_exec__(38024); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);